





// @ts-nocheck
// ^^^^^^^^^^^ Disabled TypeScript linter in this file because it doesn't understand Vue components
// which is not wrapped in Vue.extend(), and we can't use Vue.extend() in Sanity serializers
// because of how src/components/SanityBlockContent.vue initializes the serializers.

import Url from 'url-parse';
import querystring from 'query-string';

export default {
  name: 'SanityYouTubeSerializer',
  data() {
    return {
      videoId: '',
    };
  },
  created() {
    const videoUrl = new Url(this.url);
    const query = querystring.parse(videoUrl.query);
    this.videoId = query.v;
  },
  props: {
    url: String,
  },
};
